export const MQTT_PARAMS = {
    dataProcessingRequestTopic: 'GDP/DATAREQ',
    dataProcessingRequestMessageTemplate: 'GDP/%s/%s/%s/DATAREQ',
    dataRelayRequestMessageTemplate: 'GDP/%s/%s/%s/RELAYREQ',
    reqControlTopicTemplate: 'GDCREQ/%s/%s/%s',
    ackControlTopicTemplate: 'GDCCONF/%s/%s',
    swDataTopicTemplate: 'GDD/%s/%s/%s/SW',
    apDataDownlinkTopicTemplate: 'GDD/%s/%s/%s/APD',
    apCtlDownlinkTopicTemplate: 'GDD/%s/%s/%s/APCD',
    apCtlUplinkTopicTemplate: 'GDD/%s/%s/%s/APCU',
    latencyDownlinkTopicTemplate: 'GDD/%s/%s/%s/GDLD',
    latencyUplinkTopicTemplate: 'GDD/%s/%s/%s/GDLU',
    gsDataRelayTopicTemplate: 'GDDR/%s/%s/%s/GS',
    swDataRelayTopicTemplate: 'GDDR/%s/%s/%s/SW',
    apDataRelayDownlinkTopicTemplate: 'GDDR/%s/%s/%s/APD',
    apCtlRelayDownlinkTopicTemplate: 'GDDR/%s/%s/%s/APCD',
    apCtlRelayUplinkTopicTemplate: 'GDDR/%s/%s/%s/APCU',
    alertTemplate: 'GDDR/%s/%s/%s/ALERT',
};